module.exports = __webpack_public_path__ + "media/images/emblems/Trimbach-blason-e3572565d4c2ff82b3e3a71ab300c040.png";